import { render, staticRenderFns } from "./ModalMessageBox.vue?vue&type=template&id=c5b1721c&scoped=true"
import script from "./ModalMessageBox.vue?vue&type=script&lang=js"
export * from "./ModalMessageBox.vue?vue&type=script&lang=js"
import style0 from "./ModalMessageBox.vue?vue&type=style&index=0&id=c5b1721c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b1721c",
  null
  
)

export default component.exports